var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "p-0", attrs: { fluid: "" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            show: "",
            scrollable: "",
            centered: "",
            lazy: "",
            id: "my-modal-odb" + _vm.ElasticData._source.productReference,
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.getString(_vm.mode + "_Title_Popup"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.getString(_vm.mode + "_Text_Popup")),
            },
          }),
          _vm._v(" "),
          _vm.loading === true
            ? _c("div", { staticClass: "text-center my-2" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c("b-spinner"),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-2" }, [
                      _vm._v(_vm._s(_vm.getString("loading"))),
                    ]),
                  ],
                  1
                ),
              ])
            : _c("validation-observer", {
                ref: "searchRequestObserver",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ passes }) {
                      return [
                        _c(
                          "b-form",
                          {
                            staticClass: "mt-5",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return passes(_vm.sendMail)
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  label: _vm.getString("from"),
                                  "label-for": "txtFrom",
                                  "label-cols": "2",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required|email",
                                    name: _vm.getString("from"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c(
                                              "b-form-input",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    id: "txtFrom",
                                                    type: "email",
                                                    maxlength: "500",
                                                    required: "",
                                                    state: errors[0]
                                                      ? false
                                                      : valid
                                                      ? true
                                                      : null,
                                                    placeholder:
                                                      _vm.getString(
                                                        "fromInput"
                                                      ),
                                                  },
                                                  model: {
                                                    value: _vm.Email,
                                                    callback: function ($$v) {
                                                      _vm.Email = $$v
                                                    },
                                                    expression: "Email",
                                                  },
                                                },
                                                "b-form-input",
                                                _vm.$attrs,
                                                false
                                              )
                                            ),
                                            _vm._v(" "),
                                            _vm._l(errors, function (error) {
                                              return _c("p", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  label: _vm.getString("title"),
                                  "label-for": "txtTitle",
                                  "label-cols": "2",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: _vm.getString("title"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "txtTitle",
                                                type: "text",
                                                disabled: "true",
                                                maxlength: "500",
                                                required: "",
                                                state: errors[0]
                                                  ? false
                                                  : valid
                                                  ? true
                                                  : null,
                                                placeholder:
                                                  _vm.getString("titleInput"),
                                              },
                                              model: {
                                                value:
                                                  _vm.ElasticData._source
                                                    .distinctiveTitle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.ElasticData._source,
                                                    "distinctiveTitle",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "ElasticData._source.distinctiveTitle",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm._l(errors, function (error) {
                                              return _c("p", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  label: _vm.getString("count"),
                                  "label-for": "txtCount",
                                  "label-cols": "2",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required|numeric|between:1,1000000",
                                    name: _vm.getString("count"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c(
                                              "b-form-input",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    id: "txtCount",
                                                    type: "number",
                                                    min: "1",
                                                    max: "1000000",
                                                    state: errors[0]
                                                      ? false
                                                      : valid
                                                      ? true
                                                      : null,
                                                    placeholder:
                                                      _vm.getString(
                                                        "quantitiesInput"
                                                      ),
                                                  },
                                                  model: {
                                                    value: _vm.titleCount,
                                                    callback: function ($$v) {
                                                      _vm.titleCount =
                                                        _vm._n($$v)
                                                    },
                                                    expression: "titleCount",
                                                  },
                                                },
                                                "b-form-input",
                                                _vm.$attrs,
                                                false
                                              )
                                            ),
                                            _vm._v(" "),
                                            _vm._l(errors, function (error) {
                                              return _c("p", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                staticClass: "text-right",
                                attrs: {
                                  label:
                                    _vm.getString("phone") +
                                    " " +
                                    _vm.getString("optionalField"),
                                  "label-for": "txtTelephone",
                                  "label-cols": "2",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: {
                                      regex:
                                        /^(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))$/,
                                    },
                                    name: _vm.getString("phone"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ valid, errors }) {
                                          return [
                                            _c(
                                              "b-form-input",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    id: "txtTelephone",
                                                    type: "tel",
                                                    maxlength: "25",
                                                    state: errors[0]
                                                      ? false
                                                      : valid
                                                      ? true
                                                      : null,
                                                    placeholder:
                                                      _vm.getString(
                                                        "telephoneInput"
                                                      ),
                                                  },
                                                  model: {
                                                    value: _vm.telephone,
                                                    callback: function ($$v) {
                                                      _vm.telephone =
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                    },
                                                    expression: "telephone",
                                                  },
                                                },
                                                "b-form-input",
                                                _vm.$attrs,
                                                false
                                              )
                                            ),
                                            _vm._v(" "),
                                            _vm._l(errors, function (error) {
                                              return _c("p", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                staticClass: "text-right",
                                attrs: {
                                  label:
                                    _vm.getString("comment") +
                                    " (Nutzerangaben)",
                                  "label-for": "txtComment",
                                  "label-cols": "2",
                                },
                              },
                              [
                                _c(
                                  "b-form-textarea",
                                  _vm._b(
                                    {
                                      attrs: {
                                        id: "txtComment",
                                        type: "text",
                                        maxlength: "1024",
                                        placeholder:
                                          "Nutzer 1: Name, Vorname, E-Mailadresse",
                                      },
                                      model: {
                                        value: _vm.comment,
                                        callback: function ($$v) {
                                          _vm.comment =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "comment",
                                      },
                                    },
                                    "b-form-textarea",
                                    _vm.$attrs,
                                    false
                                  )
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "offset-2 d-flex flex-row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-fill" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "second-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.gotoAdvancedSearch()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getString(" Advanced search")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex justify-content-end" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "first-btn",
                                        staticStyle: { border: "none" },
                                        attrs: { type: "submit" },
                                      },
                                      [_vm._v(_vm._s(_vm.getString("Send")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "second-btn ml-2",
                                        on: {
                                          click: function ($event) {
                                            return _vm.Cancel()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.getString("Cancel")))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal",
              value: "my-modal-odb" + _vm.ElasticData._source.productReference,
              expression:
                "'my-modal-odb' + ElasticData._source.productReference ",
            },
          ],
          staticClass: "first-btn",
          staticStyle: {
            "min-width": "100%",
            "margin-bottom": "5px",
            border: "none",
          },
          on: {
            click: function ($event) {
              return _vm.getClientData()
            },
          },
        },
        [
          _vm._v(
            _vm._s(_vm.getString(_vm.mode + "_ButtonTextPopup")) + "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }